"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fluxible_router_1 = require("fluxible-router");
const GalleryStore_1 = require("../stores/GalleryStore");
const fluxible_addons_react_1 = require("fluxible-addons-react");
const helper_1 = require("../helper");
const react_helmet_1 = require("react-helmet");
const $ = require("jquery");
const ApplicationStore_1 = require("../stores/ApplicationStore");
class GalleryView extends React.Component {
    constructor(props) {
        super(props);
        this.gallery = React.createRef();
    }
    runGallery() {
        if (this.props.gallery == null) {
            return;
        }
        $(this.gallery.current).justifiedGallery({
            rowHeight: 300,
            rel: this.props.gallery.name,
        }).on('jg.complete', function () {
            $(this).find('a').colorbox({
                maxWidth: '80%',
                maxHeight: '80%',
                opacity: 0.8,
                transition: 'elastic',
                current: '',
            });
        }).css('visibility', 'visible');
    }
    componentDidUpdate() {
        this.runGallery();
    }
    componentDidMount() {
        this.runGallery();
    }
    render() {
        let i = -1;
        if (this.props.gallery == null) {
            this.props.executeAction(fluxible_router_1.navigateAction, {
                url: '/404',
                method: 'GET',
            });
            return null;
        }
        const title = this.props.gallery.name + ' - ' + this.props.siteTitle;
        return (React.createElement(React.Fragment, null,
            React.createElement(react_helmet_1.Helmet, null,
                React.createElement("title", null, title)),
            React.createElement("div", { style: { visibility: 'hidden' }, ref: this.gallery }, this.props.gallery.images != null ? this.props.gallery.images.map((image) => {
                i++;
                return (React.createElement("a", { key: image.public_id, href: image.secure_url },
                    React.createElement("img", { alt: this.props.gallery.titles[i], src: (0, helper_1.convertImageUrl)(image.secure_url) })));
            }) : null)));
    }
}
class GalleryProps {
}
exports.default = (0, fluxible_router_1.handleHistory)((0, fluxible_addons_react_1.connectToStores)(GalleryView, [GalleryStore_1.default], (context, props) => {
    return {
        gallery: context.getStore(GalleryStore_1.default).getEntity(),
        siteTitle: context.getStore(ApplicationStore_1.default).getParam('site_title') || 'xbimz.world',
        executeAction: context.executeAction,
    };
}));
